import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

export interface WorkflowStep {
  key: string;
  label: string;
  /** Ícone Material fixo da etapa. Omitido, usa o ícone derivado do statusId. */
  icon?: string;
  statusId: number | null;
  clickable?: boolean;
  locked?: boolean;
}

@Component({
    selector: 'app-workflow-column',
    templateUrl: './workflow-column.component.html',
    styleUrls: ['./workflow-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, TranslatePipe],
})
export class WorkflowColumnComponent {
  readonly steps = input<WorkflowStep[]>([]);
  readonly onStepClick = input<((step: WorkflowStep) => void) | null>(null);

  getStatusIcon(statusId: number | null): string {
    switch (statusId) {
      case 1:
        return 'check';
      case 2:
        return 'pending_actions'; // Ficha com relógio
      case 3:
        return 'hourglass_top'; // Ampulheta
      case 4:
        return 'close';
      default:
        return '';
    }
  }

  /** Ícone fixo da etapa quando declarado; senão o derivado do status. */
  getStepIcon(step: WorkflowStep): string {
    return step.icon ?? this.getStatusIcon(step.statusId);
  }

  getStatusClass(statusId: number | null): string {
    switch (statusId) {
      case 1:
        return 'approved';
      case 2:
        return 'in-progress';
      case 3:
        return 'pending';
      case 4:
        return 'rejected';
      default:
        return 'empty';
    }
  }

  isStepClickable(step: WorkflowStep): boolean {
    return !!step.clickable && !!this.onStepClick();
  }

  handleStepClick(step: WorkflowStep): void {
    if (!this.isStepClickable(step)) {
      return;
    }

    this.onStepClick()?.(step);
  }
}
